import React, {useEffect} from 'react'
import styles from './NewModal.module.sass'
import PropTypes from 'prop-types'
import CloseButton from '../Buttons/CloseButton/CloseButton'
import AttentionGenerator from '../Form/AttentionGenerator'
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";
import styled from "styled-components";


let NewModal = (props) => {
    useEffect(() => {
        let def
        def = document.querySelector('#formContainer')

        disableBodyScroll(def)
        return () => {
            enableBodyScroll(def)
        }

    })


    return (
        <div className={styles.NewModal} id={props.id} style={props.style}>
            {props.closeHandler && !props.hideCloseButton &&
            <CloseButton className={styles.closeIcon} onClick={props.closeHandler}/>}
            <div className={styles.title}>{props.title}</div>

            {
                !props.hideErrors &&
                <AttentionGenerator errors={{
                    ...props.errors

                }}/>
            }


            {props.completed
                ?
                <div className={styles.completed}>
                    <div className={styles.completedText}>{props.completedText}</div>
                    {props.completedButtonText && <button className={styles.completedButton}
                                                          onClick={props.closeHandler}>{props.completedButtonText}</button>}
                </div>
                :
                <div id="formContainer" className={styles.formContainer} style={props.containerStyle}>
                    {props.children}
                </div>
            }


        </div>
    );
}


NewModal.propTypes = {
    title: PropTypes.string.isRequired,
    completed: PropTypes.bool,
    completedText: PropTypes.string,
    completedButtonText: PropTypes.string,
    closeHandler: PropTypes.func,
    hideCloseButton: PropTypes.bool,
    hideErrors: PropTypes.bool,
    errors: PropTypes.arrayOf(
        PropTypes.shape({
            if: PropTypes.any, message: PropTypes.string
        }))
};


export default NewModal;
